/**
 * Generated by orval 🍺
 * Do not edit manually.
 * OpenGoal Admin API
 * Admin panel API — operators manage agencies, seats, roles, oversight.
 * OpenAPI spec version: 1.0
 */
import {
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  ChangePassword200,
  ChangePassword400,
  ChangePassword401,
  ChangePassword403,
  ChangePassword404,
  ChangePassword429,
  ChangePassword500,
  ChangePasswordBody,
  GetSession200,
  GetSession400,
  GetSession401,
  GetSession403,
  GetSession404,
  GetSession429,
  GetSession500,
  GetSessionPost200,
  GetSessionPost400,
  GetSessionPost401,
  GetSessionPost403,
  GetSessionPost404,
  GetSessionPost429,
  GetSessionPost500,
  GetSessionPostBody,
  ListUserSessions400,
  ListUserSessions401,
  ListUserSessions403,
  ListUserSessions404,
  ListUserSessions429,
  ListUserSessions500,
  PostV1AuthRevokeOtherSessions200,
  PostV1AuthRevokeOtherSessions400,
  PostV1AuthRevokeOtherSessions401,
  PostV1AuthRevokeOtherSessions403,
  PostV1AuthRevokeOtherSessions404,
  PostV1AuthRevokeOtherSessions429,
  PostV1AuthRevokeOtherSessions500,
  PostV1AuthRevokeOtherSessionsBody,
  PostV1AuthRevokeSession200,
  PostV1AuthRevokeSession400,
  PostV1AuthRevokeSession401,
  PostV1AuthRevokeSession403,
  PostV1AuthRevokeSession404,
  PostV1AuthRevokeSession429,
  PostV1AuthRevokeSession500,
  PostV1AuthRevokeSessionBody,
  PostV1AuthRevokeSessions200,
  PostV1AuthRevokeSessions400,
  PostV1AuthRevokeSessions401,
  PostV1AuthRevokeSessions403,
  PostV1AuthRevokeSessions404,
  PostV1AuthRevokeSessions429,
  PostV1AuthRevokeSessions500,
  PostV1AuthRevokeSessionsBody,
  RequestPasswordReset200,
  RequestPasswordReset400,
  RequestPasswordReset401,
  RequestPasswordReset403,
  RequestPasswordReset404,
  RequestPasswordReset429,
  RequestPasswordReset500,
  RequestPasswordResetBody,
  ResetPassword200,
  ResetPassword400,
  ResetPassword401,
  ResetPassword403,
  ResetPassword404,
  ResetPassword429,
  ResetPassword500,
  ResetPasswordBody,
  Session,
  SignInEmail200,
  SignInEmail400,
  SignInEmail401,
  SignInEmail403,
  SignInEmail404,
  SignInEmail429,
  SignInEmail500,
  SignInEmailBody,
  SignOut200,
  SignOut400,
  SignOut401,
  SignOut403,
  SignOut404,
  SignOut429,
  SignOut500,
  SignOutBody
} from '../model';

import { apiRequest } from '../../client.ts';




const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

export const getSignInEmailUrl = () => {




  return `/v1/auth/sign-in/email`
}

/**
 * Sign in with email and password
 */
export const signInEmail = async (signInEmailBody: SignInEmailBody, options?: RequestInit): Promise<SignInEmail200> => {

  return apiRequest<SignInEmail200>(getSignInEmailUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(signInEmailBody)
  }
);}





export const getSignInEmailQueryKey = (signInEmailBody?: SignInEmailBody,) => {
    return [
    'POST', `/v1/auth/sign-in/email`, signInEmailBody
    ] as const;
    }


export const getSignInEmailQueryOptions = <TData = Awaited<ReturnType<typeof signInEmail>>, TError = SignInEmail400 | SignInEmail401 | SignInEmail403 | SignInEmail404 | SignInEmail429 | SignInEmail500>(signInEmailBody: SignInEmailBody, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof signInEmail>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getSignInEmailQueryKey(signInEmailBody);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof signInEmail>>> = ({ signal }) => signInEmail(signInEmailBody, { signal });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof signInEmail>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type SignInEmailQueryResult = NonNullable<Awaited<ReturnType<typeof signInEmail>>>
export type SignInEmailQueryError = SignInEmail400 | SignInEmail401 | SignInEmail403 | SignInEmail404 | SignInEmail429 | SignInEmail500


export function useSignInEmail<TData = Awaited<ReturnType<typeof signInEmail>>, TError = SignInEmail400 | SignInEmail401 | SignInEmail403 | SignInEmail404 | SignInEmail429 | SignInEmail500>(
 signInEmailBody: SignInEmailBody, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof signInEmail>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof signInEmail>>,
          TError,
          Awaited<ReturnType<typeof signInEmail>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useSignInEmail<TData = Awaited<ReturnType<typeof signInEmail>>, TError = SignInEmail400 | SignInEmail401 | SignInEmail403 | SignInEmail404 | SignInEmail429 | SignInEmail500>(
 signInEmailBody: SignInEmailBody, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof signInEmail>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof signInEmail>>,
          TError,
          Awaited<ReturnType<typeof signInEmail>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useSignInEmail<TData = Awaited<ReturnType<typeof signInEmail>>, TError = SignInEmail400 | SignInEmail401 | SignInEmail403 | SignInEmail404 | SignInEmail429 | SignInEmail500>(
 signInEmailBody: SignInEmailBody, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof signInEmail>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useSignInEmail<TData = Awaited<ReturnType<typeof signInEmail>>, TError = SignInEmail400 | SignInEmail401 | SignInEmail403 | SignInEmail404 | SignInEmail429 | SignInEmail500>(
 signInEmailBody: SignInEmailBody, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof signInEmail>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getSignInEmailQueryOptions(signInEmailBody,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getSignOutUrl = () => {




  return `/v1/auth/sign-out`
}

/**
 * Sign out the current user
 */
export const signOut = async (signOutBody?: SignOutBody, options?: RequestInit): Promise<SignOut200> => {

  return apiRequest<SignOut200>(getSignOutUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(signOutBody)
  }
);}





export const getSignOutQueryKey = (signOutBody?: SignOutBody,) => {
    return [
    'POST', `/v1/auth/sign-out`, signOutBody
    ] as const;
    }


export const getSignOutQueryOptions = <TData = Awaited<ReturnType<typeof signOut>>, TError = SignOut400 | SignOut401 | SignOut403 | SignOut404 | SignOut429 | SignOut500>(signOutBody?: SignOutBody, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof signOut>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getSignOutQueryKey(signOutBody);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof signOut>>> = ({ signal }) => signOut(signOutBody, { signal });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof signOut>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type SignOutQueryResult = NonNullable<Awaited<ReturnType<typeof signOut>>>
export type SignOutQueryError = SignOut400 | SignOut401 | SignOut403 | SignOut404 | SignOut429 | SignOut500


export function useSignOut<TData = Awaited<ReturnType<typeof signOut>>, TError = SignOut400 | SignOut401 | SignOut403 | SignOut404 | SignOut429 | SignOut500>(
 signOutBody: undefined |  SignOutBody, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof signOut>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof signOut>>,
          TError,
          Awaited<ReturnType<typeof signOut>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useSignOut<TData = Awaited<ReturnType<typeof signOut>>, TError = SignOut400 | SignOut401 | SignOut403 | SignOut404 | SignOut429 | SignOut500>(
 signOutBody?: SignOutBody, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof signOut>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof signOut>>,
          TError,
          Awaited<ReturnType<typeof signOut>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useSignOut<TData = Awaited<ReturnType<typeof signOut>>, TError = SignOut400 | SignOut401 | SignOut403 | SignOut404 | SignOut429 | SignOut500>(
 signOutBody?: SignOutBody, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof signOut>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useSignOut<TData = Awaited<ReturnType<typeof signOut>>, TError = SignOut400 | SignOut401 | SignOut403 | SignOut404 | SignOut429 | SignOut500>(
 signOutBody?: SignOutBody, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof signOut>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getSignOutQueryOptions(signOutBody,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getGetSessionUrl = () => {




  return `/v1/auth/get-session`
}

/**
 * Get the current session
 */
export const getSession = async ( options?: RequestInit): Promise<GetSession200> => {

  return apiRequest<GetSession200>(getGetSessionUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetSessionQueryKey = () => {
    return [
    `/v1/auth/get-session`
    ] as const;
    }


export const getGetSessionQueryOptions = <TData = Awaited<ReturnType<typeof getSession>>, TError = GetSession400 | GetSession401 | GetSession403 | GetSession404 | GetSession429 | GetSession500>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSession>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetSessionQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getSession>>> = ({ signal }) => getSession({ signal });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getSession>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetSessionQueryResult = NonNullable<Awaited<ReturnType<typeof getSession>>>
export type GetSessionQueryError = GetSession400 | GetSession401 | GetSession403 | GetSession404 | GetSession429 | GetSession500


export function useGetSession<TData = Awaited<ReturnType<typeof getSession>>, TError = GetSession400 | GetSession401 | GetSession403 | GetSession404 | GetSession429 | GetSession500>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSession>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSession>>,
          TError,
          Awaited<ReturnType<typeof getSession>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetSession<TData = Awaited<ReturnType<typeof getSession>>, TError = GetSession400 | GetSession401 | GetSession403 | GetSession404 | GetSession429 | GetSession500>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSession>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSession>>,
          TError,
          Awaited<ReturnType<typeof getSession>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetSession<TData = Awaited<ReturnType<typeof getSession>>, TError = GetSession400 | GetSession401 | GetSession403 | GetSession404 | GetSession429 | GetSession500>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSession>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetSession<TData = Awaited<ReturnType<typeof getSession>>, TError = GetSession400 | GetSession401 | GetSession403 | GetSession404 | GetSession429 | GetSession500>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSession>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetSessionQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getGetSessionPostUrl = () => {




  return `/v1/auth/get-session`
}

/**
 * Get the current session
 */
export const getSessionPost = async (getSessionPostBody?: GetSessionPostBody, options?: RequestInit): Promise<GetSessionPost200> => {

  return apiRequest<GetSessionPost200>(getGetSessionPostUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(getSessionPostBody)
  }
);}





export const getGetSessionPostQueryKey = (getSessionPostBody?: GetSessionPostBody,) => {
    return [
    'POST', `/v1/auth/get-session`, getSessionPostBody
    ] as const;
    }


export const getGetSessionPostQueryOptions = <TData = Awaited<ReturnType<typeof getSessionPost>>, TError = GetSessionPost400 | GetSessionPost401 | GetSessionPost403 | GetSessionPost404 | GetSessionPost429 | GetSessionPost500>(getSessionPostBody?: GetSessionPostBody, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSessionPost>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetSessionPostQueryKey(getSessionPostBody);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getSessionPost>>> = ({ signal }) => getSessionPost(getSessionPostBody, { signal });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getSessionPost>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetSessionPostQueryResult = NonNullable<Awaited<ReturnType<typeof getSessionPost>>>
export type GetSessionPostQueryError = GetSessionPost400 | GetSessionPost401 | GetSessionPost403 | GetSessionPost404 | GetSessionPost429 | GetSessionPost500


export function useGetSessionPost<TData = Awaited<ReturnType<typeof getSessionPost>>, TError = GetSessionPost400 | GetSessionPost401 | GetSessionPost403 | GetSessionPost404 | GetSessionPost429 | GetSessionPost500>(
 getSessionPostBody: undefined |  GetSessionPostBody, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSessionPost>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSessionPost>>,
          TError,
          Awaited<ReturnType<typeof getSessionPost>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetSessionPost<TData = Awaited<ReturnType<typeof getSessionPost>>, TError = GetSessionPost400 | GetSessionPost401 | GetSessionPost403 | GetSessionPost404 | GetSessionPost429 | GetSessionPost500>(
 getSessionPostBody?: GetSessionPostBody, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSessionPost>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSessionPost>>,
          TError,
          Awaited<ReturnType<typeof getSessionPost>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetSessionPost<TData = Awaited<ReturnType<typeof getSessionPost>>, TError = GetSessionPost400 | GetSessionPost401 | GetSessionPost403 | GetSessionPost404 | GetSessionPost429 | GetSessionPost500>(
 getSessionPostBody?: GetSessionPostBody, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSessionPost>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetSessionPost<TData = Awaited<ReturnType<typeof getSessionPost>>, TError = GetSessionPost400 | GetSessionPost401 | GetSessionPost403 | GetSessionPost404 | GetSessionPost429 | GetSessionPost500>(
 getSessionPostBody?: GetSessionPostBody, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSessionPost>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetSessionPostQueryOptions(getSessionPostBody,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getRequestPasswordResetUrl = () => {




  return `/v1/auth/request-password-reset`
}

/**
 * Send a password reset email to the user
 */
export const requestPasswordReset = async (requestPasswordResetBody: RequestPasswordResetBody, options?: RequestInit): Promise<RequestPasswordReset200> => {

  return apiRequest<RequestPasswordReset200>(getRequestPasswordResetUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(requestPasswordResetBody)
  }
);}





export const getRequestPasswordResetQueryKey = (requestPasswordResetBody?: RequestPasswordResetBody,) => {
    return [
    'POST', `/v1/auth/request-password-reset`, requestPasswordResetBody
    ] as const;
    }


export const getRequestPasswordResetQueryOptions = <TData = Awaited<ReturnType<typeof requestPasswordReset>>, TError = RequestPasswordReset400 | RequestPasswordReset401 | RequestPasswordReset403 | RequestPasswordReset404 | RequestPasswordReset429 | RequestPasswordReset500>(requestPasswordResetBody: RequestPasswordResetBody, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof requestPasswordReset>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getRequestPasswordResetQueryKey(requestPasswordResetBody);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof requestPasswordReset>>> = ({ signal }) => requestPasswordReset(requestPasswordResetBody, { signal });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof requestPasswordReset>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type RequestPasswordResetQueryResult = NonNullable<Awaited<ReturnType<typeof requestPasswordReset>>>
export type RequestPasswordResetQueryError = RequestPasswordReset400 | RequestPasswordReset401 | RequestPasswordReset403 | RequestPasswordReset404 | RequestPasswordReset429 | RequestPasswordReset500


export function useRequestPasswordReset<TData = Awaited<ReturnType<typeof requestPasswordReset>>, TError = RequestPasswordReset400 | RequestPasswordReset401 | RequestPasswordReset403 | RequestPasswordReset404 | RequestPasswordReset429 | RequestPasswordReset500>(
 requestPasswordResetBody: RequestPasswordResetBody, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof requestPasswordReset>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof requestPasswordReset>>,
          TError,
          Awaited<ReturnType<typeof requestPasswordReset>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useRequestPasswordReset<TData = Awaited<ReturnType<typeof requestPasswordReset>>, TError = RequestPasswordReset400 | RequestPasswordReset401 | RequestPasswordReset403 | RequestPasswordReset404 | RequestPasswordReset429 | RequestPasswordReset500>(
 requestPasswordResetBody: RequestPasswordResetBody, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof requestPasswordReset>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof requestPasswordReset>>,
          TError,
          Awaited<ReturnType<typeof requestPasswordReset>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useRequestPasswordReset<TData = Awaited<ReturnType<typeof requestPasswordReset>>, TError = RequestPasswordReset400 | RequestPasswordReset401 | RequestPasswordReset403 | RequestPasswordReset404 | RequestPasswordReset429 | RequestPasswordReset500>(
 requestPasswordResetBody: RequestPasswordResetBody, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof requestPasswordReset>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useRequestPasswordReset<TData = Awaited<ReturnType<typeof requestPasswordReset>>, TError = RequestPasswordReset400 | RequestPasswordReset401 | RequestPasswordReset403 | RequestPasswordReset404 | RequestPasswordReset429 | RequestPasswordReset500>(
 requestPasswordResetBody: RequestPasswordResetBody, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof requestPasswordReset>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getRequestPasswordResetQueryOptions(requestPasswordResetBody,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getResetPasswordUrl = () => {




  return `/v1/auth/reset-password`
}

/**
 * Reset the password for a user
 */
export const resetPassword = async (resetPasswordBody: ResetPasswordBody, options?: RequestInit): Promise<ResetPassword200> => {

  return apiRequest<ResetPassword200>(getResetPasswordUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(resetPasswordBody)
  }
);}





export const getResetPasswordQueryKey = (resetPasswordBody?: ResetPasswordBody,) => {
    return [
    'POST', `/v1/auth/reset-password`, resetPasswordBody
    ] as const;
    }


export const getResetPasswordQueryOptions = <TData = Awaited<ReturnType<typeof resetPassword>>, TError = ResetPassword400 | ResetPassword401 | ResetPassword403 | ResetPassword404 | ResetPassword429 | ResetPassword500>(resetPasswordBody: ResetPasswordBody, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof resetPassword>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getResetPasswordQueryKey(resetPasswordBody);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof resetPassword>>> = ({ signal }) => resetPassword(resetPasswordBody, { signal });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof resetPassword>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ResetPasswordQueryResult = NonNullable<Awaited<ReturnType<typeof resetPassword>>>
export type ResetPasswordQueryError = ResetPassword400 | ResetPassword401 | ResetPassword403 | ResetPassword404 | ResetPassword429 | ResetPassword500


export function useResetPassword<TData = Awaited<ReturnType<typeof resetPassword>>, TError = ResetPassword400 | ResetPassword401 | ResetPassword403 | ResetPassword404 | ResetPassword429 | ResetPassword500>(
 resetPasswordBody: ResetPasswordBody, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof resetPassword>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof resetPassword>>,
          TError,
          Awaited<ReturnType<typeof resetPassword>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useResetPassword<TData = Awaited<ReturnType<typeof resetPassword>>, TError = ResetPassword400 | ResetPassword401 | ResetPassword403 | ResetPassword404 | ResetPassword429 | ResetPassword500>(
 resetPasswordBody: ResetPasswordBody, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof resetPassword>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof resetPassword>>,
          TError,
          Awaited<ReturnType<typeof resetPassword>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useResetPassword<TData = Awaited<ReturnType<typeof resetPassword>>, TError = ResetPassword400 | ResetPassword401 | ResetPassword403 | ResetPassword404 | ResetPassword429 | ResetPassword500>(
 resetPasswordBody: ResetPasswordBody, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof resetPassword>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useResetPassword<TData = Awaited<ReturnType<typeof resetPassword>>, TError = ResetPassword400 | ResetPassword401 | ResetPassword403 | ResetPassword404 | ResetPassword429 | ResetPassword500>(
 resetPasswordBody: ResetPasswordBody, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof resetPassword>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getResetPasswordQueryOptions(resetPasswordBody,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getChangePasswordUrl = () => {




  return `/v1/auth/change-password`
}

/**
 * Change the password of the user
 */
export const changePassword = async (changePasswordBody: ChangePasswordBody, options?: RequestInit): Promise<ChangePassword200> => {

  return apiRequest<ChangePassword200>(getChangePasswordUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(changePasswordBody)
  }
);}





export const getChangePasswordQueryKey = (changePasswordBody?: ChangePasswordBody,) => {
    return [
    'POST', `/v1/auth/change-password`, changePasswordBody
    ] as const;
    }


export const getChangePasswordQueryOptions = <TData = Awaited<ReturnType<typeof changePassword>>, TError = ChangePassword400 | ChangePassword401 | ChangePassword403 | ChangePassword404 | ChangePassword429 | ChangePassword500>(changePasswordBody: ChangePasswordBody, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof changePassword>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getChangePasswordQueryKey(changePasswordBody);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof changePassword>>> = ({ signal }) => changePassword(changePasswordBody, { signal });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof changePassword>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ChangePasswordQueryResult = NonNullable<Awaited<ReturnType<typeof changePassword>>>
export type ChangePasswordQueryError = ChangePassword400 | ChangePassword401 | ChangePassword403 | ChangePassword404 | ChangePassword429 | ChangePassword500


export function useChangePassword<TData = Awaited<ReturnType<typeof changePassword>>, TError = ChangePassword400 | ChangePassword401 | ChangePassword403 | ChangePassword404 | ChangePassword429 | ChangePassword500>(
 changePasswordBody: ChangePasswordBody, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof changePassword>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof changePassword>>,
          TError,
          Awaited<ReturnType<typeof changePassword>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useChangePassword<TData = Awaited<ReturnType<typeof changePassword>>, TError = ChangePassword400 | ChangePassword401 | ChangePassword403 | ChangePassword404 | ChangePassword429 | ChangePassword500>(
 changePasswordBody: ChangePasswordBody, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof changePassword>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof changePassword>>,
          TError,
          Awaited<ReturnType<typeof changePassword>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useChangePassword<TData = Awaited<ReturnType<typeof changePassword>>, TError = ChangePassword400 | ChangePassword401 | ChangePassword403 | ChangePassword404 | ChangePassword429 | ChangePassword500>(
 changePasswordBody: ChangePasswordBody, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof changePassword>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useChangePassword<TData = Awaited<ReturnType<typeof changePassword>>, TError = ChangePassword400 | ChangePassword401 | ChangePassword403 | ChangePassword404 | ChangePassword429 | ChangePassword500>(
 changePasswordBody: ChangePasswordBody, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof changePassword>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getChangePasswordQueryOptions(changePasswordBody,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getListUserSessionsUrl = () => {




  return `/v1/auth/list-sessions`
}

/**
 * List all active sessions for the user
 */
export const listUserSessions = async ( options?: RequestInit): Promise<Session[]> => {

  return apiRequest<Session[]>(getListUserSessionsUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListUserSessionsQueryKey = () => {
    return [
    `/v1/auth/list-sessions`
    ] as const;
    }


export const getListUserSessionsQueryOptions = <TData = Awaited<ReturnType<typeof listUserSessions>>, TError = ListUserSessions400 | ListUserSessions401 | ListUserSessions403 | ListUserSessions404 | ListUserSessions429 | ListUserSessions500>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listUserSessions>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListUserSessionsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listUserSessions>>> = ({ signal }) => listUserSessions({ signal });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listUserSessions>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListUserSessionsQueryResult = NonNullable<Awaited<ReturnType<typeof listUserSessions>>>
export type ListUserSessionsQueryError = ListUserSessions400 | ListUserSessions401 | ListUserSessions403 | ListUserSessions404 | ListUserSessions429 | ListUserSessions500


export function useListUserSessions<TData = Awaited<ReturnType<typeof listUserSessions>>, TError = ListUserSessions400 | ListUserSessions401 | ListUserSessions403 | ListUserSessions404 | ListUserSessions429 | ListUserSessions500>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listUserSessions>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listUserSessions>>,
          TError,
          Awaited<ReturnType<typeof listUserSessions>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListUserSessions<TData = Awaited<ReturnType<typeof listUserSessions>>, TError = ListUserSessions400 | ListUserSessions401 | ListUserSessions403 | ListUserSessions404 | ListUserSessions429 | ListUserSessions500>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listUserSessions>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listUserSessions>>,
          TError,
          Awaited<ReturnType<typeof listUserSessions>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListUserSessions<TData = Awaited<ReturnType<typeof listUserSessions>>, TError = ListUserSessions400 | ListUserSessions401 | ListUserSessions403 | ListUserSessions404 | ListUserSessions429 | ListUserSessions500>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listUserSessions>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useListUserSessions<TData = Awaited<ReturnType<typeof listUserSessions>>, TError = ListUserSessions400 | ListUserSessions401 | ListUserSessions403 | ListUserSessions404 | ListUserSessions429 | ListUserSessions500>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listUserSessions>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListUserSessionsQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getPostV1AuthRevokeSessionUrl = () => {




  return `/v1/auth/revoke-session`
}

/**
 * Revoke a single session
 */
export const postV1AuthRevokeSession = async (postV1AuthRevokeSessionBody?: PostV1AuthRevokeSessionBody, options?: RequestInit): Promise<PostV1AuthRevokeSession200> => {

  return apiRequest<PostV1AuthRevokeSession200>(getPostV1AuthRevokeSessionUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(postV1AuthRevokeSessionBody)
  }
);}





export const getPostV1AuthRevokeSessionQueryKey = (postV1AuthRevokeSessionBody?: PostV1AuthRevokeSessionBody,) => {
    return [
    'POST', `/v1/auth/revoke-session`, postV1AuthRevokeSessionBody
    ] as const;
    }


export const getPostV1AuthRevokeSessionQueryOptions = <TData = Awaited<ReturnType<typeof postV1AuthRevokeSession>>, TError = PostV1AuthRevokeSession400 | PostV1AuthRevokeSession401 | PostV1AuthRevokeSession403 | PostV1AuthRevokeSession404 | PostV1AuthRevokeSession429 | PostV1AuthRevokeSession500>(postV1AuthRevokeSessionBody?: PostV1AuthRevokeSessionBody, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof postV1AuthRevokeSession>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getPostV1AuthRevokeSessionQueryKey(postV1AuthRevokeSessionBody);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof postV1AuthRevokeSession>>> = ({ signal }) => postV1AuthRevokeSession(postV1AuthRevokeSessionBody, { signal });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof postV1AuthRevokeSession>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type PostV1AuthRevokeSessionQueryResult = NonNullable<Awaited<ReturnType<typeof postV1AuthRevokeSession>>>
export type PostV1AuthRevokeSessionQueryError = PostV1AuthRevokeSession400 | PostV1AuthRevokeSession401 | PostV1AuthRevokeSession403 | PostV1AuthRevokeSession404 | PostV1AuthRevokeSession429 | PostV1AuthRevokeSession500


export function usePostV1AuthRevokeSession<TData = Awaited<ReturnType<typeof postV1AuthRevokeSession>>, TError = PostV1AuthRevokeSession400 | PostV1AuthRevokeSession401 | PostV1AuthRevokeSession403 | PostV1AuthRevokeSession404 | PostV1AuthRevokeSession429 | PostV1AuthRevokeSession500>(
 postV1AuthRevokeSessionBody: undefined |  PostV1AuthRevokeSessionBody, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof postV1AuthRevokeSession>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof postV1AuthRevokeSession>>,
          TError,
          Awaited<ReturnType<typeof postV1AuthRevokeSession>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function usePostV1AuthRevokeSession<TData = Awaited<ReturnType<typeof postV1AuthRevokeSession>>, TError = PostV1AuthRevokeSession400 | PostV1AuthRevokeSession401 | PostV1AuthRevokeSession403 | PostV1AuthRevokeSession404 | PostV1AuthRevokeSession429 | PostV1AuthRevokeSession500>(
 postV1AuthRevokeSessionBody?: PostV1AuthRevokeSessionBody, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof postV1AuthRevokeSession>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof postV1AuthRevokeSession>>,
          TError,
          Awaited<ReturnType<typeof postV1AuthRevokeSession>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function usePostV1AuthRevokeSession<TData = Awaited<ReturnType<typeof postV1AuthRevokeSession>>, TError = PostV1AuthRevokeSession400 | PostV1AuthRevokeSession401 | PostV1AuthRevokeSession403 | PostV1AuthRevokeSession404 | PostV1AuthRevokeSession429 | PostV1AuthRevokeSession500>(
 postV1AuthRevokeSessionBody?: PostV1AuthRevokeSessionBody, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof postV1AuthRevokeSession>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function usePostV1AuthRevokeSession<TData = Awaited<ReturnType<typeof postV1AuthRevokeSession>>, TError = PostV1AuthRevokeSession400 | PostV1AuthRevokeSession401 | PostV1AuthRevokeSession403 | PostV1AuthRevokeSession404 | PostV1AuthRevokeSession429 | PostV1AuthRevokeSession500>(
 postV1AuthRevokeSessionBody?: PostV1AuthRevokeSessionBody, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof postV1AuthRevokeSession>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getPostV1AuthRevokeSessionQueryOptions(postV1AuthRevokeSessionBody,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getPostV1AuthRevokeSessionsUrl = () => {




  return `/v1/auth/revoke-sessions`
}

/**
 * Revoke all sessions for the user
 */
export const postV1AuthRevokeSessions = async (postV1AuthRevokeSessionsBody?: PostV1AuthRevokeSessionsBody, options?: RequestInit): Promise<PostV1AuthRevokeSessions200> => {

  return apiRequest<PostV1AuthRevokeSessions200>(getPostV1AuthRevokeSessionsUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(postV1AuthRevokeSessionsBody)
  }
);}





export const getPostV1AuthRevokeSessionsQueryKey = (postV1AuthRevokeSessionsBody?: PostV1AuthRevokeSessionsBody,) => {
    return [
    'POST', `/v1/auth/revoke-sessions`, postV1AuthRevokeSessionsBody
    ] as const;
    }


export const getPostV1AuthRevokeSessionsQueryOptions = <TData = Awaited<ReturnType<typeof postV1AuthRevokeSessions>>, TError = PostV1AuthRevokeSessions400 | PostV1AuthRevokeSessions401 | PostV1AuthRevokeSessions403 | PostV1AuthRevokeSessions404 | PostV1AuthRevokeSessions429 | PostV1AuthRevokeSessions500>(postV1AuthRevokeSessionsBody?: PostV1AuthRevokeSessionsBody, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof postV1AuthRevokeSessions>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getPostV1AuthRevokeSessionsQueryKey(postV1AuthRevokeSessionsBody);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof postV1AuthRevokeSessions>>> = ({ signal }) => postV1AuthRevokeSessions(postV1AuthRevokeSessionsBody, { signal });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof postV1AuthRevokeSessions>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type PostV1AuthRevokeSessionsQueryResult = NonNullable<Awaited<ReturnType<typeof postV1AuthRevokeSessions>>>
export type PostV1AuthRevokeSessionsQueryError = PostV1AuthRevokeSessions400 | PostV1AuthRevokeSessions401 | PostV1AuthRevokeSessions403 | PostV1AuthRevokeSessions404 | PostV1AuthRevokeSessions429 | PostV1AuthRevokeSessions500


export function usePostV1AuthRevokeSessions<TData = Awaited<ReturnType<typeof postV1AuthRevokeSessions>>, TError = PostV1AuthRevokeSessions400 | PostV1AuthRevokeSessions401 | PostV1AuthRevokeSessions403 | PostV1AuthRevokeSessions404 | PostV1AuthRevokeSessions429 | PostV1AuthRevokeSessions500>(
 postV1AuthRevokeSessionsBody: undefined |  PostV1AuthRevokeSessionsBody, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof postV1AuthRevokeSessions>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof postV1AuthRevokeSessions>>,
          TError,
          Awaited<ReturnType<typeof postV1AuthRevokeSessions>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function usePostV1AuthRevokeSessions<TData = Awaited<ReturnType<typeof postV1AuthRevokeSessions>>, TError = PostV1AuthRevokeSessions400 | PostV1AuthRevokeSessions401 | PostV1AuthRevokeSessions403 | PostV1AuthRevokeSessions404 | PostV1AuthRevokeSessions429 | PostV1AuthRevokeSessions500>(
 postV1AuthRevokeSessionsBody?: PostV1AuthRevokeSessionsBody, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof postV1AuthRevokeSessions>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof postV1AuthRevokeSessions>>,
          TError,
          Awaited<ReturnType<typeof postV1AuthRevokeSessions>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function usePostV1AuthRevokeSessions<TData = Awaited<ReturnType<typeof postV1AuthRevokeSessions>>, TError = PostV1AuthRevokeSessions400 | PostV1AuthRevokeSessions401 | PostV1AuthRevokeSessions403 | PostV1AuthRevokeSessions404 | PostV1AuthRevokeSessions429 | PostV1AuthRevokeSessions500>(
 postV1AuthRevokeSessionsBody?: PostV1AuthRevokeSessionsBody, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof postV1AuthRevokeSessions>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function usePostV1AuthRevokeSessions<TData = Awaited<ReturnType<typeof postV1AuthRevokeSessions>>, TError = PostV1AuthRevokeSessions400 | PostV1AuthRevokeSessions401 | PostV1AuthRevokeSessions403 | PostV1AuthRevokeSessions404 | PostV1AuthRevokeSessions429 | PostV1AuthRevokeSessions500>(
 postV1AuthRevokeSessionsBody?: PostV1AuthRevokeSessionsBody, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof postV1AuthRevokeSessions>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getPostV1AuthRevokeSessionsQueryOptions(postV1AuthRevokeSessionsBody,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getPostV1AuthRevokeOtherSessionsUrl = () => {




  return `/v1/auth/revoke-other-sessions`
}

/**
 * Revoke all other sessions for the user except the current one
 */
export const postV1AuthRevokeOtherSessions = async (postV1AuthRevokeOtherSessionsBody?: PostV1AuthRevokeOtherSessionsBody, options?: RequestInit): Promise<PostV1AuthRevokeOtherSessions200> => {

  return apiRequest<PostV1AuthRevokeOtherSessions200>(getPostV1AuthRevokeOtherSessionsUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(postV1AuthRevokeOtherSessionsBody)
  }
);}





export const getPostV1AuthRevokeOtherSessionsQueryKey = (postV1AuthRevokeOtherSessionsBody?: PostV1AuthRevokeOtherSessionsBody,) => {
    return [
    'POST', `/v1/auth/revoke-other-sessions`, postV1AuthRevokeOtherSessionsBody
    ] as const;
    }


export const getPostV1AuthRevokeOtherSessionsQueryOptions = <TData = Awaited<ReturnType<typeof postV1AuthRevokeOtherSessions>>, TError = PostV1AuthRevokeOtherSessions400 | PostV1AuthRevokeOtherSessions401 | PostV1AuthRevokeOtherSessions403 | PostV1AuthRevokeOtherSessions404 | PostV1AuthRevokeOtherSessions429 | PostV1AuthRevokeOtherSessions500>(postV1AuthRevokeOtherSessionsBody?: PostV1AuthRevokeOtherSessionsBody, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof postV1AuthRevokeOtherSessions>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getPostV1AuthRevokeOtherSessionsQueryKey(postV1AuthRevokeOtherSessionsBody);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof postV1AuthRevokeOtherSessions>>> = ({ signal }) => postV1AuthRevokeOtherSessions(postV1AuthRevokeOtherSessionsBody, { signal });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof postV1AuthRevokeOtherSessions>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type PostV1AuthRevokeOtherSessionsQueryResult = NonNullable<Awaited<ReturnType<typeof postV1AuthRevokeOtherSessions>>>
export type PostV1AuthRevokeOtherSessionsQueryError = PostV1AuthRevokeOtherSessions400 | PostV1AuthRevokeOtherSessions401 | PostV1AuthRevokeOtherSessions403 | PostV1AuthRevokeOtherSessions404 | PostV1AuthRevokeOtherSessions429 | PostV1AuthRevokeOtherSessions500


export function usePostV1AuthRevokeOtherSessions<TData = Awaited<ReturnType<typeof postV1AuthRevokeOtherSessions>>, TError = PostV1AuthRevokeOtherSessions400 | PostV1AuthRevokeOtherSessions401 | PostV1AuthRevokeOtherSessions403 | PostV1AuthRevokeOtherSessions404 | PostV1AuthRevokeOtherSessions429 | PostV1AuthRevokeOtherSessions500>(
 postV1AuthRevokeOtherSessionsBody: undefined |  PostV1AuthRevokeOtherSessionsBody, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof postV1AuthRevokeOtherSessions>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof postV1AuthRevokeOtherSessions>>,
          TError,
          Awaited<ReturnType<typeof postV1AuthRevokeOtherSessions>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function usePostV1AuthRevokeOtherSessions<TData = Awaited<ReturnType<typeof postV1AuthRevokeOtherSessions>>, TError = PostV1AuthRevokeOtherSessions400 | PostV1AuthRevokeOtherSessions401 | PostV1AuthRevokeOtherSessions403 | PostV1AuthRevokeOtherSessions404 | PostV1AuthRevokeOtherSessions429 | PostV1AuthRevokeOtherSessions500>(
 postV1AuthRevokeOtherSessionsBody?: PostV1AuthRevokeOtherSessionsBody, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof postV1AuthRevokeOtherSessions>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof postV1AuthRevokeOtherSessions>>,
          TError,
          Awaited<ReturnType<typeof postV1AuthRevokeOtherSessions>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function usePostV1AuthRevokeOtherSessions<TData = Awaited<ReturnType<typeof postV1AuthRevokeOtherSessions>>, TError = PostV1AuthRevokeOtherSessions400 | PostV1AuthRevokeOtherSessions401 | PostV1AuthRevokeOtherSessions403 | PostV1AuthRevokeOtherSessions404 | PostV1AuthRevokeOtherSessions429 | PostV1AuthRevokeOtherSessions500>(
 postV1AuthRevokeOtherSessionsBody?: PostV1AuthRevokeOtherSessionsBody, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof postV1AuthRevokeOtherSessions>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function usePostV1AuthRevokeOtherSessions<TData = Awaited<ReturnType<typeof postV1AuthRevokeOtherSessions>>, TError = PostV1AuthRevokeOtherSessions400 | PostV1AuthRevokeOtherSessions401 | PostV1AuthRevokeOtherSessions403 | PostV1AuthRevokeOtherSessions404 | PostV1AuthRevokeOtherSessions429 | PostV1AuthRevokeOtherSessions500>(
 postV1AuthRevokeOtherSessionsBody?: PostV1AuthRevokeOtherSessionsBody, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof postV1AuthRevokeOtherSessions>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getPostV1AuthRevokeOtherSessionsQueryOptions(postV1AuthRevokeOtherSessionsBody,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






